import Decorate from '@tencent/spaui-decorate';
import { Dialog, DialogProps } from '@tencent/spaui';
import _ from 'lodash';

const defaultOptions = {
  useNewUI: true,
  closeButton: true,
  cancelButton: true,
  submitLabel: '确定',
  className: '',
};

export const genMsgFun = (typeOptions: any = {}) => (children: any, options: DialogProps = {}) => {
  const dialog = new Decorate(Dialog);
  const _options = {
    ...defaultOptions,
    ...typeOptions,
    ...options,
  };
  const { needReject = false } = _options;
  return new Promise((resolve, reject) => {
    dialog.setProps({
      show: true,
      title: '提示',
      children,
      ..._options,
      onClose() {
        if (_.isFunction(_options.onClose)) {
          _options.onClose();
        }
        dialog.destroy();
        needReject && reject();
      },
      onCancel() {
        if (_.isFunction(_options.onCancel)) {
          _options.onCancel();
        }
        dialog.destroy();
        needReject && reject();
      },
      onSubmit: () => {
        if (_.isFunction(_options.beforeSubmit) && !_options.beforeSubmit()) {
          return;
        }
        if (_.isFunction(_options.onSubmit)) {
          _options.onSubmit();
        }
        dialog.destroy();
        resolve(null);
      },
    });
  });
};

const loadingDialog = new Decorate(Dialog);

const showLoading = (message: any, options = {}) => {
  loadingDialog.setProps({
    show: true,
    children: message,
    type: 'tip',
    iconType: 'loading',
    ...options,
  });
};

const hideLoading = () => {
  loadingDialog.setProps({
    show: false,
  });
};

export default {
  alert: genMsgFun({ closeButton: false, cancelButton: false }),
  confirm: genMsgFun({ needReject: true }),
  notation: genMsgFun({
    useNewUI: false,
    type: 'normal',
    cancelButton: false,
    submitLabel: '我知道了',
    className: 'mg-modal mg-notation-modal spaui-dialog-confirm-normal',
  }),
  showLoading,
  hideLoading,
};
